import React from "react"
import { IDate, ISchedulePatternTemplate } from "../../../../../models"
import _ from "lodash"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import moment from "moment"
import * as positionHelper from "../../../../../helpers/positionHelper"
import { Card } from "material-ui"
import AccountStore from "../../../../../stores/AccountStore"
import AppStateStore from "../../../../../stores/AppStateStore"

interface IProps {
    rowHeight: number
    patternTemplates: ISchedulePatternTemplate[]
    // it's local time
    dayDate: IDate
    employeeList: any
}

const ScheduleResourcePlannerWeeklyDailyByEmployeeItem: React.SFC<IProps> = (props: IProps) => {
    const patternTemplatesForDay = scheduleHelper.getPatternTemplatesByDate(props.dayDate, props.patternTemplates)
        .filter((pt) => !pt.Deleted)
        .sort((a, b) => {
            if (a.AssignedUserId && b.AssignedUserId) return 0
            if (a.AssignedUserId < b.AssignedUserId) return -1
            if (a.AssignedUserId > b.AssignedUserId) return 1
        }).sort((a, b) => {
            if (a.AssignedUserName === b.AssignedUserName) return 0
            if (a.AssignedUserName < b.AssignedUserName) return -1
            if (a.AssignedUserName > b.AssignedUserName) return 1
        }).sort((a, b) => {
            if (!a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 0
            if (!a.ShiftTemplates[0].Position && b.ShiftTemplates[0].Position) return -1
            if (a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 1
            if (a.ShiftTemplates[0].Position.Name === b.ShiftTemplates[0].Position.Name) return 0
            if (a.ShiftTemplates[0].Position.Name < b.ShiftTemplates[0].Position.Name) return -1
            if (a.ShiftTemplates[0].Position.Name > b.ShiftTemplates[0].Position.Name) return 1
        })

    return (
        <Card>
            <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
                <div style={{ display: "grid", gridTemplateColumns: "auto min-content", position: "sticky", top: AppStateStore.getTopBarHeight(), zIndex: 1, backgroundColor: "white" }}>
                    <div style={{ gridColumn: 1 }}>
                        <div style={{ fontSize: 16, fontWeight: 700 }}>
                            {moment(props.dayDate).format("dddd")}
                        </div>
                        <div style={{ fontSize: 12, fontWeight: 500 }}>
                            {moment(props.dayDate).format("MM/DD/YY")}
                        </div>
                    </div>
                </div>
                {props.employeeList && props.employeeList.length > 0 &&
                    <table cellSpacing={0} cellPadding={3} style={{ fontSize: 11, width: "100%" }}>
                        {props.employeeList.map((employee, index) => {
                            let row = patternTemplatesForDay.filter(item => item.AssignedUserId == employee.Id)[0] //TODO: Handle multiple shifts per person, per day. Show consolidated view or list of shifts
                            if (!row) {
                                return (
                                    <tr key={index}>
                                        <td style={{
                                            gridRow: index,
                                            height: props.rowHeight,
                                        }}>
                                            -
                                        </td>
                                        <td style={{
                                            gridRow: index,
                                            height: props.rowHeight,
                                        }}>
                                        </td>
                                        <td style={{
                                            gridRow: index,
                                            height: props.rowHeight,
                                        }} >
                                        </td>
                                    </tr>
                                )
                            }
                            const positionColor = positionHelper.getPositionColorFromBasePositionId(row.ShiftTemplates[0].Position && row.ShiftTemplates[0].Position.BasePositionId)
                            const backgroundColor = scheduleHelper.getTransparentBackgroundColor(positionColor)
                            const fadeBackground = scheduleHelper.getTransparentBackgroundColorFade(positionColor, "#ffffff")
                            const jobName = row.ShiftTemplates[0].JobName ? row.ShiftTemplates[0].JobName : ""
                            const positionName = row.ShiftTemplates[0].Position ? row.ShiftTemplates[0].Position.Name : ""
                            return (
                                <tr key={index} style={{ height: props.rowHeight }}>
                                    {AccountStore.getJobsEnabled() &&
                                        <td
                                            id={"schedule-row-item-" + row.Id}
                                            className="TextOverflow"
                                            style={{
                                                gridRow: index,
                                                height: props.rowHeight,
                                                color: positionColor,
                                                maxWidth: 30,
                                                backgroundColor,
                                            }}
                                        >
                                            <span title={jobName}>
                                                {jobName}
                                            </span>
                                        </td>
                                    }
                                    <td
                                        id={"schedule-row-item-" + row.Id}
                                        className="TextOverflow"
                                        style={{
                                            gridRow: index,
                                            height: props.rowHeight,
                                            color: positionColor,
                                            maxWidth: 30,
                                            backgroundColor,
                                        }}
                                    >
                                        <span title={positionName}>
                                            {positionName}
                                        </span>
                                    </td>
                                    <td style={{
                                        gridRow: index,
                                        height: props.rowHeight,
                                        maxWidth: 30,
                                        backgroundColor,
                                    }}>
                                        {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].StartTime)).format(row.ShiftTemplates[0].StartTime.Minute == 0 ? "ha" : "h:mma").slice(0, -1)}
                                    </td>
                                    <td style={{
                                        gridRow: index,
                                        height: props.rowHeight,
                                        maxWidth: 30,
                                        background: fadeBackground
                                    }} >
                                        {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].EndTime)).format(row.ShiftTemplates[0].EndTime.Minute == 0 ? "ha" : "h:mma").slice(0, -1)}
                                    </td>
                                </tr>
                            )
                        })}
                    </table>
                }
            </div>
        </Card>
    )
}

export default ScheduleResourcePlannerWeeklyDailyByEmployeeItem